import { getVueTemplate } from "../../_imports/utils/utils.common";
import { leave, smoothEnter, rollUp, rollDown } from "./utils/transitions.vue";
import { ifCanPushDatalayer } from "../../_imports/dataLayers/utils/utils.dataLayer.common";
import Fuse from "fuse.js";
import acceptedCookiePolicy from "../../../components/onetrust/cookiePolicy";
import logAmplitudeEvent from "../../../components/amplitude";
import { result } from "lodash";
import { property } from "lodash";

const htmlElement = document.querySelector("html");

export default {
    name: "skills-selector",
    template: getVueTemplate("skills-selector"),
    data() {
        return {
            searchValue: "",
            skills: [],
            modalOpened: false,
            showNumberOfSelectedSkills: false,
            selectedSkills: [],
            currentSelectedSkills: [],
            skillsHasBeenUpdated: false,
            skillsSearchValue: "",
            querySkills: "",
            hiddenSkills: 0,
        };
    },
    props: {
        isSearchBySkillsLight: Boolean,
        initialSearchValue: String,
        initialSkillsSet: Array,
    },
    mixins: [leave, smoothEnter, rollUp, rollDown],
    computed: {
        filteredSkills() {
            const options = {
                isCaseSensitive: false,
                shouldSort: true,
                minMatchCharLength: 2,
                threshold: 0.4,
            };

            const fuse = new Fuse(this.skills, options);

            const pattern = this.skillsSearchValue;

            const fuseResult = fuse.search(pattern);
            if (!fuseResult.length) {
                return this.skills;
            }
            return fuseResult.map((value) => value.item);
        },
        inputIsVisible() {
            return !this.isSearchBySkillsLight && (this.selectedSkills.length === 0 || this.modalOpened);
        },
        showNumber() {
            return this.showNumberOfSelectedSkills && !this.modalOpened && this.selectedSkills.length !== 0;
        },
    },
    watch: {
        selectedSkills() {
            this.querySkills = this.convertSkillsInString(this.selectedSkills);
        },
        initialSearchValue(newValue) {
            this.searchValue = newValue;
        },
    },
    methods: {
        openSkillSelector() {
            this.modalOpened = true;
            if (this.isSearchBySkillsLight) {
                this.toggleModalCareerClass();
            }

            if (!this.isSearchBySkillsLight) {
                this.$refs.tagsContainer.classList.remove("wrap");
                this.showNumberOfSelectedSkills = false;
                this.hideSkillsTags();
            } else {
                this.currentSelectedSkills = this.selectedSkills;

                scroll({
                    top: 0,
                    behavior: "smooth",
                });
            }

            this.autoFocusInput();
        },
        closeSkillsSelector() {
            this.modalOpened = false;

            if (this.isSearchBySkillsLight) {
                this.toggleModalCareerClass();
            }

            if (!this.isSearchBySkillsLight) {
                setTimeout(() => {
                    this.detectTagsContainerWidthAndWrap();
                    this.displaySkillsTags();
                }, 1);

                return;
            }

            if (this.skillsChanged() && !this.skillsHasBeenUpdated) {
                Coveo.executeQuery(document.body);
            }
        },
        toggleModalCareerClass() {
            if (htmlElement.classList.contains("modal-career-open")) {
                htmlElement.classList.remove("modal-career-open");
                htmlElement.classList.add("modal-career-closed");
            } else {
                htmlElement.classList.add("modal-career-open");
                htmlElement.classList.remove("modal-career-closed");
            }
        },
        hideSkillsTags() {
            const tags = this.$refs.tagsContainer.querySelectorAll(".selected-skill-tag");

            tags.forEach((tag) => {
                tag.classList.add("invisible");
            });
        },
        convertSkillsInString(skills) {
            let skillsString = skills.toString().split(",").join('", "');
            return `${skillsString.toLowerCase()}`;
        },
        displaySkillsTags() {
            const invisibleTags = this.$refs.tagsContainer.querySelectorAll(".invisible");

            if (invisibleTags) {
                invisibleTags.forEach((tag) => tag.classList.remove("invisible"));
            }
        },
        removeSkillFromSelection(skillToRemove) {
            this.selectedSkills = this.selectedSkills.filter((skill) => {
                return skill.toLowerCase().split(" ").join("") !== skillToRemove.toLowerCase().split(" ").join("");
            });
            if (!this.modalOpened) {
                setTimeout(() => {
                    Coveo.executeQuery(document.body);
                }, 500);
            }
        },
        clearSelection() {
            this.selectedSkills = [];
            this.searchValue = "";

            setTimeout(() => {
                if (!this.modalOpened) {
                    Coveo.executeQuery(document.body);
                }
            }, 500);
        },
        updateSelection() {
            this.skillsHasBeenUpdated = true;

            if (this.isSearchBySkillsLight && this.skillsChanged()) {
                Coveo.executeQuery(document.body);
            }

            this.closeSkillsSelector();
            this.skillsHasBeenUpdated = false;
        },
        skillsChanged() {
            return this.currentSelectedSkills.length !== this.selectedSkills.length;
        },
        getSkillsFromSitecore() {
            if (typeof CoveoWebsite !== 'undefined') {
                const skillsInfos = CoveoWebsite.careers?.skills;
                if (skillsInfos) {
                    skillsInfos.forEach((skill) => {
                        this.skills.push(skill.name);
                    });
                }
            }
        },

        dataLayerCareerSkillPush(skill) {
            ifCanPushDatalayer({
                then: () => {
                    dataLayerBus.push({
                        event: "user_interaction",
                        event_name: "refined_job_search",
                        interaction: {
                            search_term: Coveo.state(document.body, "q"),
                            skill: skill,
                        },
                    });
                    logAmplitudeEvent({
                        event_type: "Filter Applied",
                        properties: {
                            filter_name: skill
                        }
                    })
                },
            });
        },
        dataLayerCareerPush() {
            if (Coveo.state(document.body, "q")) {
                ifCanPushDatalayer({
                    then: () => {
                        dataLayerBus.push({
                            event: "user_interaction",
                            event_name: "job_search",
                            interaction: {
                                search_term: Coveo.state(document.body, "q"),
                            },
                        });
                    },
                });
                acceptedCookiePolicy({
                    ifPerformanceCookies: () => {
                        if (OnetrustActiveGroups.includes("C0004")) {
                            logAmplitudeEvent({
                                event_type: "Search Performed",
                                properties: {
                                    search_query: Coveo.state(document.body, "q")
                                }
                            });
                        }
                    }
                });
            }
        },
        selectSkill() {
            if (this.skillsSearchValue && this.filteredSkills.length === 1) {
                if (!this.selectedSkills.includes(this.filteredSkills[0])) {
                    this.selectedSkills.push(this.filteredSkills[0]);
                }
            }
        },
        emitSelectedSkillsUrl(event) {
            let stringSkills = "";
            const searchValue = this.searchValue;

            this.selectedSkills.forEach((skill) => {
                skill = skill.split(" ").join("").replace(".", "");

                stringSkills = stringSkills.concat(skill + "_");
            });

            this.$root.$emit("willRedirect", event, {
                searchValue,
                stringSkills,
            });
        },
        detectTagsContainerWidthAndWrap() {
            const tagsContainerWidth = this.$refs.tagsContainer.offsetWidth + 40;
            const inputContainerWidth = this.$refs.skillsInputContainer.offsetWidth - 24;
            const tagsContainer = this.$refs.tagsContainer;
            let firstSkillPositionY = "";

            this.hiddenSkills = 0;

            tagsContainer.classList.remove("wrap");
            this.showNumberOfSelectedSkills = false;

            if (tagsContainerWidth >= inputContainerWidth) {
                tagsContainer.classList.add("wrap");
                this.showNumberOfSelectedSkills = true;
            }

            if (this.$refs.selectedSkill) {
                this.$refs.selectedSkill.forEach((skill, index) => {
                    if (index === 0) {
                        firstSkillPositionY = skill.getBoundingClientRect().y;
                    }

                    if (skill.getBoundingClientRect().y !== firstSkillPositionY) {
                        this.hiddenSkills++;
                    }
                });
            }
        },
        mapUrlSkillsAndSelectedSkills(initialSkillsSet) {
            initialSkillsSet.forEach((initialSkill) => {
                this.skills.forEach((skill) => {
                    const formatedSkill = skill.toLowerCase().split(" ").join("").replace(".", "")

                    if (formatedSkill === initialSkill.toLowerCase()) {
                        this.selectedSkills.push(skill);
                    }
                });
            });
        },
        triggerDataLayers() {
            this.dataLayerCareerPush();
            const skills = this.selectedSkills;

            skills.forEach((skill) => {
                this.dataLayerCareerSkillPush(skill);
            });
        },

        triggerNewSearchOnPageload() {
            if (this.searchValue) {
                Coveo.$$(document.body).on("restoreHistoryState", () => {
                    Coveo.state(document.body, {
                        q: this.searchValue,
                    });
                });
            }
        },
        activateDataLayers() {
            Coveo.$$(document.body).on("deferredQuerySuccess", () => {
                this.triggerDataLayers();
            });
        },
        addSkillsToCoveoRequest() {
            Coveo.$$(document.body).on("doneBuildingQuery", (e, args) => {
                if (this.querySkills !== "") {
                    args.queryBuilder.advancedExpression.add(`(@title=("${this.querySkills}") OR @integrationdescription=("${this.querySkills}"))`);
                }
            });
        },
        autoFocusInput() {
            setTimeout(() => {
                this.$refs.inputModal.focus();
            }, 1);
        },
    },
    mounted() {
        setTimeout(() => {
            this.$el.classList.add("component-is-mounted");
            this.getSkillsFromSitecore();

            if (this.isSearchBySkillsLight) {
                if (this.initialSkillsSet) {
                    this.mapUrlSkillsAndSelectedSkills(this.initialSkillsSet);
                }

                this.activateDataLayers();
                this.addSkillsToCoveoRequest();
                this.triggerNewSearchOnPageload();
            }
        }, 50);
    },
    directives: {
        "click-outside": {
            bind: function (el, binding) {
                const handler = (event) => {
                    if (!el.contains(event.target) && el !== event.target && !event.target.classList.contains("selected-skill")) {
                        binding.value(event);
                    }
                };
                el.vueClickOutside = handler;

                document.addEventListener("click", handler);
            },

            unbind: function (el, binding) {
                document.removeEventListener("click", el.vueClickOutside);
                el.vueClickOutside = null;
            },
        },
    },
};
